import { QueryClient } from '@tanstack/react-query';

import { QUERY_RETRY_COUNT, QUERY_STALE_TIME_MS } from '@/config/constants.js';

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_STALE_TIME_MS,
        retry: QUERY_RETRY_COUNT,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: 0 },
    },
  });
}
